import React, { useEffect, useState } from "react";
import { Amplify, Auth, Hub } from "aws-amplify";
import { Spin, Layout } from "antd";
import awsconfig from "./aws-exports";
import Nav from "./components/Navigation/Nav";
import home from "./media/kn-logo.png";
import team from "./media/kn-truck.png";
import "./index.css";
import { Button } from "@awsui/components-react";

const { Header, Content } = Layout;
const IDLE_TIMEOUT = 60 * 60 * 1000; // 1 hour in milliseconds

Amplify.configure(awsconfig);

function Home(props) {
  return (
    <Layout className="site-layout" style={{
      backgroundImage: `url(${team})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '100vh'
    }}>
      <Header className="site-layout-background" style={{ padding: 0, background: 'transparent' }} />
      <Content className="layout" style={{ background: 'transparent', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', height: 'calc(100vh - 64px)', paddingRight: '10%', paddingTop: '2%' }}>
        <Spin spinning={props.loading} size="large">
          <div style={{ textAlign: 'center', background: 'white', padding: '24px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center', width: '280px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#003366', margin: 0, lineHeight: '1.4' }}>
              Temporary Elevated Access Portal
            </h3>
            <Button
              variant="primary"
              onClick={() => Auth.federatedSignIn({ provider: 'IdentityCenter' })}
              style={{ width: '100%' }}
            >
              Federated Sign In
            </Button>
          </div>
        </Spin>
      </Content>
    </Layout>
  );
}
function App() {
  const [user, setUser] = useState(null);
  const [groups, setGroups] = useState(null);
  const [cognitoGroups, setcognitoGroups] = useState([]);
  const [userId, setUserId] = useState(null);
  const [groupIds, setGroupIds] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Hub.listen("auth", ({ payload: { event, data } }) => {
      // eslint-disable-next-line default-case
      switch (event) {
        case "signIn":
          console.log("User signed in");
          break;
        // eslint-disable-next-line no-fallthrough
        case "cognitoHostedUI":
          setData();
          break;
        case "signOut":
          console.log("User signed out");
          setLoading(false);
          break;
        case "signIn_failure":
          console.log("User sign in failure");
          break;
        case "cognitoHostedUI_failure":
          console.log("Sign in failure");
          break;
      }
    });

    setData();
  }, []);

  // Idle timeout detection
  useEffect(() => {
    let idleTimer;

    const resetTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        console.log("User idle timeout - signing out");
        Auth.signOut();
      }, IDLE_TIMEOUT);
    };

    const events = ['mousemove', 'keypress', 'click', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      clearTimeout(idleTimer);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, []);

  function setData() {
    getUser().then((userData) => {
      if (!userData) {
        setLoading(false);
        return;
      }
      setUser(userData);
      const payload = userData.signInUserSession.idToken.payload;
      setcognitoGroups(payload["cognito:groups"]);
      setUserId(payload.userId);
      setGroupIds((payload.groupIds).split(','));
      setGroups((payload.groups).split(','));
      setLoading(false);
    });
  }

  async function getUser() {
    try {
      const userData = await Auth.currentAuthenticatedUser();
      return userData;
    } catch {
      setLoading(false);
      return console.log("Not signed in");
    }
  }

  return (
    <div>
      {groups ? (
        <Nav
          user={user}
          groupIds={groupIds}
          userId={userId}
          groups={groups}
          cognitoGroups={cognitoGroups}
        />
      ) : (
        <Home loading={loading} />
      )}
    </div>
  );
}

export default App;
